var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-content-wrapper"},[(_vm.id)?_c('div',{class:'page-content light-blue-bg ' + _vm.className,style:(_vm.initStyle),attrs:{"id":_vm.id}},[_vm._t("default")],2):_c('div',{class:'page-content light-blue-bg ' + _vm.className,style:(_vm.initStyle)},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }